export default {
  //columnName
  columnName: {
    name: "名稱",
    storenumber: "門市編號",
    storename: "門市名稱",
    terminalnumber: "收銀台編號",
    terminalname: "收銀台名稱",
    foodkindnumber: "類別編號",
    foodkindname: "類別名稱",
    onlineordercategoryname: "類別名稱",
    foodmajorkindnumber: "大類別編號",
    foodmajorkindname: "大類別名稱",
    barcode: "條碼",
    barcode2: "條碼2",
    barcode3: "條碼3",
    departmentnumber: "部門編號",
    departmentname: "部門名稱",
    foodnumber: "商品編號",
    onlineorderitemname: "商品名稱",
    foodname: "商品名稱",
    foodname2: "商品名稱2",
    foodmemo: "備註",
    qty: "數量",
    safeqty: "安全存量",
    lackqty: "不足量",
    pickedqty: "已取量",
    notpickedqty: "未取量",
    salprice: "單價",
    salprice1: "售價1",
    salprice2: "售價2",
    salprice3: "售價3",
    salprice4: "售價4",
    salprice5: "售價5",
    salprice6: "售價6",
    discountsalprice: "促銷金額",
    cost: "成本",
    totalcost: "總成本",
    avgcost: "平均成本",
    totalavgcost: "總成本(平均)",
    differencetotalcost: "盈虧總成本",
    differencetotal: "盈虧總價",
    grossprofit: "毛利",
    profit: "毛利",
    grossmargin: "毛利率",
    foodsaleproportion: "商品銷售比",
    saleproportion: "銷售比",
    total: "小計",
    saltotal: "單據總計",
    alltotal: "單據總計",
    saletotal: "銷售額",
    salereturntotal: "銷退額",
    totaldiscountprice: "折扣金額",
    saletotaldiscountprice: "單據折扣金額",
    discountprice: "折扣金額",
    totalfreeprice: "折讓金額",
    freeprice: "折讓金額",
    unit: "單位",
    employeenumber: "員工編號",
    employeename: "員工名稱",
    salernumber: "業務員編號",
    salername: "業務員名稱",
    warehousenumber: "倉庫編號",
    warehousename: "倉庫名稱",
    fromwarehousenumber: "調出倉庫編號",
    fromwarehousename: "調出倉庫名稱",
    towarehousenumber: "調入倉庫編號",
    towarehousename: "調入倉庫名稱",
    suppliernumber: "廠商編號",
    suppliername: "廠商名稱",
    purchasetotal: "進貨金額",
    purchasereturntotal: "退貨金額",
    salefoodname: "自訂商品",
    customernumber: "會員編號",
    customerid: "會員編號",
    customername: "會員名稱",
    email: "電子信箱",
    telephone: "電話",
    cellphone: "手機",
    memo: "備註",
    tradememo: "單據備註",
    salmemo: "單據備註",
    gender: "性別",
    username: "名稱",
    roletype: "角色",
    businessid: "營業人編號",
    businessname: "營業人名稱",
    combokindname: "套餐類別名稱",
    comboname: "套餐名稱",
    tastekindname: "口味類別名稱",
    onlineordermodifiergroupname: "自訂項目名稱",
    tastename: "口味名稱",
    onlineordermodifiername: "口味名稱",
    price: "金額",
    invoicedate: "發票日期",
    invoicenumber: "發票號碼",
    period: "期別",
    postalcode: "郵遞區號",
    address: "地址",
    phone: "電話",
    invoiceemail: "寄送Email",
    invoiceprizetype: "中獎獎別",
    invoiceprizeamount: "中獎金額",
    invoiceprizenumber: "中獎號碼",
    businessnumber: "統一編號",
    purchasenumber: "單號",
    purchaseordernumber: "採購單號",
    salnumber: "單號",
    tradenumber: "單號",
    depositrecordnumber: "儲值單號",
    purchasedate: "日期",
    businessday: "營業日期",
    businessclass: "班別",
    stockadjustnumber: "調整單號",
    stockadjustdate: "調整日期",
    fromstockadjustnumber: "調出調整單號",
    tostockadjustnumber: "調入調整單號",
    stocktransfernumber: "調撥單號",
    stocktransferdate: "調撥日期",
    checkqty: "點收數量",
    checkername: "點收人",
    buildername: "建立者",
    paytype: "付款類別",
    payname: "付款名稱",
    salepaytype: "付款方式",
    functionname: "功能名稱",
    functionshowname: "功能名稱",
    functiontypetext: "功能別",
    value: "值",
    directorytype: "科目種類",
    directorytypetext: "科目種類",
    directorykindname: "科目類別名稱",
    directoryname: "科目名稱",
    moduletype: "模組種類",
    modulename: "模組名稱",
    promotionname: "群組名稱",
    promotiondetname: "小群組名稱",
    buyernumber: "採購員編號",
    buyername: "採購員",
    receiptnumber: "收款單號",
    receiptdate: "收款日期",
    paymentnumber: "付款單號",
    paymentdate: "付款日期",
    tradetype: "交易別",
    tradetypetext: "交易別",
    eattype: "用餐別",
    eattypetext: "用餐別",
    payable: "原應付金額",
    payed: "已付金額",
    nopay: "未付金額",
    accountdate: "結帳日",
    receivable: "應收金額",
    received: "已收金額",
    downloadname: "名稱",
    counts: "次數",
    salecounts: "交易次數",
    voidcounts: "作廢次數",
    foodcounts: "商品數",
    foodaveragesalprice: "商品平均單價",
    totalperreceipt: "每單平均消費",
    foodcountsperreceipt: "每單平均商品數",
    peopleperreceipt: "每單平均人數",
    totalperperson: "客單價",
    foodcountsperperson: "每人平均商品數",
    people: "人數",
    time: "時段",
    times: "次數",
    invoicebegin: "起",
    invoiceend: "訖",
    ytaxprice: "應稅額",
    taxprice: "稅額",
    ytaxpriceincludetax: "含稅額",
    ztaxprice: "零稅額",
    ntaxprice: "免稅額",
    netprice: "淨額",
    difference: "盈虧",
    sheets: "張數",
    invoicevoid: "作廢",
    voidsheets: "作廢張數",
    saltime: "銷售時間",
    invoicetime: "銷售時間",
    deliverytime: "取貨時間",
    tradetime: "交易時間",
    createtime: "建立時間",
    updatetime: "最後修改時間",
    cash: "現金",
    change: "找零",
    uniformnumber: "統一編號",
    inventorydate: "盤點日期",
    inventorynumber: "盤點單號",
    inventoryqty: "盤點數量",
    stockqty: "庫存數量",
    initialqty: "期初庫存量",
    lastqty: "期末庫存量",
    salqty: "銷售數量",
    voidsalqty: "銷退數量",
    purchaseqty: "進貨數量",
    purchaseprice: "進貨價格",
    purchasereturnqty: "進退數量",
    adjustqty: "調整數量",
    combinationinqty: "組合入庫",
    combinationoutqty: "領料扣庫",
    seperationinqty: "拆解扣庫",
    seperationoutqty: "退料入庫",
    transferinqty: "撥入",
    transferoutqty: "撥出",
    tradedate: "交易日期",
    deviceid: "收銀台編號",
    devicename: "收銀台名稱",
    cpuid: "金鑰",
    statustype: "狀態",
    statustypetext: "狀態",
    principlenumber: "負責人編號",
    principlename: "負責人名稱",
    daybegin: "開始日期",
    dayend: "結束日期",
    timebegin: "開始時間",
    timeend: "結束時間",
    sunday: "日",
    monday: "一",
    tuesday: "二",
    wednesday: "三",
    thursday: "四",
    friday: "五",
    saturday: "六",
    daymodulename: "時間模組",
    integral: "積點",
    integraladd: "獲得積點",
    integralminus: "折抵積點",
    birth: "生日",
    degree: "等級",
    degreetext: "等級",
    memberlabel: "群組",
    customerleveltypetext: "會員分級",
    days: "累積天數",
    memberupgraderule: "等級",
    memberupgraderuletext: "等級",
    creditcardprice: "信用卡金額",
    creditcardnumber: "信用卡號",
    paytype1: "結帳別1",
    paytype2: "結帳別2",
    linepay: "LINE Pay",
    linepayprice: "LINE Pay",
    scan2pay: "Scan2Pay",
    scan2payprice: "Scan2Pay",
    pxpayprice: "全支付",
    couponprice: "折價券",
    deposit: "儲值金",
    depositminus: "使用儲值金",
    lastrechargeamount: "剩餘可儲值金額",
    executetime: "交易時間",
    easycardprice: "悠遊卡",
    number: "號碼",
    overcharge: "溢收",
    originalprice: "單價",
    originaltotal: "原總價",
    originalqty: "原數量",
    identifier: "識別碼",
    totallength: "總長度",
    pricelabeltype: "種類",
    foodposition: "商品位置",
    foodlength: "商品長度",
    priceposition: "價格位置",
    pricelength: "價格長度",
    pricedecimalnumber: "價格小數位",
    qtyposition: "數量位置",
    qtylength: "數量長度",
    qtydecimalnumber: "數量小數位",
    discount: "折扣",
    towork: "上班時間",
    offwork: "下班時間",
    worktime: "工時",
    worktimehour: "工時(時)",
    worktimeminute: "工時(分)",
    devicecounts: "台數",
    principle: "負責人",
    contactperson: "聯絡人",
    faxnumber: "傳真號碼",
    startdate: "開始日期",
    enddate: "結束日期",
    months: "月",
    monthlyfee: "月租費",
    freedeposit: "贈送儲值金",
    beforedeposit: "儲值金(前)",
    afterdeposit: "儲值金(後)",
    beforestock: "庫存量(前)",
    peopletype1: "客群1",
    peopletype2: "客群2",
    peopletype3: "客群3",
    peopletype4: "客群4",
    totalpeople: "總人數",
    lywarehousenumber: "凌越倉庫編號",
    lyuniformnumber: "凌越申報統編",
    vehiclenumber: "載具號碼",
    originalinvoice: "原發票號碼",
    modulestorename: "門市模組名稱",
    isfinalpaymentpayed: "已付尾款",
    isadvancedpayed: "已付訂金",
    finalpayment: "尾款",
    finalpaymentdate: "完成時間",
    advanceddeposit: "訂金",
    advanceddepositnumber: "訂金單號",
    finalpaymentnumber: "尾款單號",
    producttype: "產品名稱",
    producttypetext: "產品名稱",
    accountnumber: "帳戶編號",
    accountname: "帳戶名稱",
    couponname: "折價券名稱",
    expiredate: "到期日",
    sourcesalnumber: "來源單號",
    sourcesaltime: "來源時間",
    sourceterminalnumber: "來源收銀台編號",
    sourceterminalname: "來源收銀台",
    discountsalnumber: "使用單號",
    discountsaltime: "使用時間",
    discountterminalnumber: "使用收銀台編號",
    discountterminalname: "使用收銀台",
    onlineorderstorename: "商店名稱",
    onlineorderphone: "商店電話",
    onlineorderaddress: "商店地址",
    collectionpaymenttype: "種類",
    onlineordermenuname: "菜單名稱",
    minqty: "必選",
    maxqty: "上限",
    taxtype: "稅別",
    taxtypetext: "稅別",
    starttime: "開始時間",
    endtime: "結束時間",
    combinationtradedate: "組合日期",
    combinationtradenumber: "組合單號",
    seperationtradedate: "拆解日期",
    seperationtradenumber: "拆解單號",
    combinationwarehousenumber: "主件倉庫編號",
    combinationwarehousename: "主件倉庫名稱",
    combinationfoodnumber: "主件品號",
    combinationfoodname: "主件品名",
    combinationqty: "主件數量",
    combinationtotal: "主件總計",
    combinationunit: "主件單位",
    stockadjusttype: "調整類別",
    stockadjusttypetext: "調整類別",
    promotiontype: "促銷種類",
    promotiontypetext: "促銷種類",
    balance: "沖帳金額",
    ocardruleid: "ID",
    ocardrulename: "名稱",
    ocardpromotiontype: "促銷規則",
    ocardpromotiontypetext: "促銷規則",
    ocardrulefoodnametext: "兌換商品",
    promotionvalue: "值",
    salesperson: "業務員",
    partner: "購買公司",
    utailocationtype: "公司所在地",
    utailocationtypetext: "公司所在地",
    applytype: "申請模式",
    applytypetext: "申請模式",
    termleasetype: "使用期間",
    termleasetypetext: "使用期間",
    companyname: "公司名稱",
    companypostalcode: "公司郵遞區號",
    companyaddress: "公司地址",
    taxnumber: "稅籍編號",
    taxationbureau: "所屬國稅局",
    storepostalcode: "郵遞區號",
    storeaddress: "門市地址",
    principalname: "負責人姓名",
    principalphone: "負責人電話",
    principalfax: "負責人傳真",
    principalemail: "負責人Email",
    contactpersonphone: "聯絡人電話",
    contactpersondax: "聯絡人傳真",
    contactpersonemail: "聯絡人Email",
    invoicesheets: "每月預計開立發票",
    invoiceincreasesheets: "增加發票張數",
    maingoods: "主要販售商品",
    receiver: "收件人名稱",
    receiveraddress: "收件人地址",
    receivertelephone: "收件人電話",
    receiverphone: "收件人手機",
    applicationid: "ID",
    ishead: "總分支機構",
    isheadtext: "總分支機構",
    extraprice: "加價",
    isselect: "預選",
    add: "新增",
    remove: "移除",
    pricemarkup: "加價",
    alladd: "全選",
    min: "必選",
    max: "上限",
    use: "使用",
    delete: "刪除",
    fullnumber: "滿",
    isrepeat: "重複折扣",
    modify: "修改",
    isvoid: "已作廢",
    changestatus: "變更狀態",
    status: "狀態",
    select: "選擇",
    selectall: "全選",
    item: "項目",
    isinvoicehassend: "發票寄送Mail",
    iselecinvoicesendemail: "發票寄送Mail",
    isinvoicehasprint: "發票列印",
    pgtalkprice: "PGTalk",
    pgtalkpt: "PGTalk PT",
    validmonths: "有效月份",
    keeptotal: "續會金額",
    keepmonths: "續會統計月份",
    visiontype: "處方",
    visiontypetext: "處方",
    builddate: "建立時間",
    batchnumber: "批號",
    phone1: "電話 1",
    phone2: "電話 2",
    changepricetype: "促銷別",
    changepricetypetext: "促銷別",
    salpricetype: "售價別",
    salpricetypetext: "售價別",
    hasbatchnumber: "啟用批號",
    purchaseorderqty: "採購數量",
    saleorderqty: "訂單數量",
    sequence: "排序",
    agencystartdate: "委任開始日期",
    availablyqty: "可用量",
    downloaditemname: "下載項目名稱",
    issuccess: "已下載",
    issuccesstext: "是否成功",
    onlineordermenu: "菜單",
    onlineordermenutext: "菜單",
    degreestartdate: "自動升等開始",
    degreeenddate: "自動升等結束",
    specificationtypename: "規格類型",
    specificationname: "規格名稱",
    terminalid: "收銀台ID",
    apitype: "API類型",
    apitypetext: "API類型",
    requesturl: "請求網址",
    requestmethod: "請求方法",
    responsecode: "狀態碼",
    issucccess: "是否成功",
    durationtime: "持續時間",
    requesttime: "請求時間",
    thirdpartytype: "第三方類型",
    thirdpartytypetext: "第三方類型",
    httpmethod: "請求方法",
    durationseconds: "持續秒數",
    userid: "使用者ID",
    systemlogtype: "系統紀錄類型",
    systemlogtypetext: "系統紀錄類型",
    description: "敘述",
    requestcontent: "Request Content",
    responsecontent: "Response Content",
    requestbody: "Request Body",
    notificationtype: "推播類型",
    notificationtypetext: "推播類型",
    orderid: "訂單ID",
    lastnotificationtime: "最後推播時間",
    resendtimes: "傳送次數",
    webhooklogid: "回呼紀錄ID",
    webhooktype: "回呼類型",
    webhooktypetext: "回呼類型",
    clientip: "客戶端IP",
    transactionid: "交易ID",
    errormsg: "錯誤訊息",
    signature: "簽名",
    id: "ID",
    apptype: "App Type",
    floormapid: "樓層ID",
    tablemapid: "桌位ID",
    tablemapname: "桌位名稱",
    partid: "桌位ID",
    index: "項次",
    body: "Body",
    thirdpartybody: "Third Party Body",
    authcode: "授權碼",
    cardnumber: "卡號",
    creditcardtradenumber: "交易序號",
    brandname: "品牌名稱",
    brandnumber: "品牌編號",
    broadcastid: "Broadcast Id",
    version: "版本",
    ubereats: "UberEats",
    ubereatsprice: "UberEats",
    purchasememo: "單據備註",
    originalsalnumber: "原單號",
    retailprice: "零售價",
    iserp: "進銷存",
    isdining: "後結",
    industrytypetext: "行業別",
    promotionmodetype: "贈送方式",
    promotionmodetypetext: "贈送方式",
    actualsaleqty: "實際銷量",
    istoworkrepair: "補上班",
    istoworkrepairtext: "補上班",
    isoffworkrepair: "補下班",
    isoffworkrepairtext: "補下班",
    creditcardpaytype: "信用卡支付別",
    creditcardpaytypetext: "信用卡支付別",
    ipassprice: "一卡通",
    ipassmoneyprice: "iPASS Money",
    jkopayprice: "街口支付",
    twpayprice: "台灣Pay",
    piwalletprice: "Pi錢包",
    easywalletprice: "悠遊付",
    openemployeenumber: "開帳員工編號",
    openemployeename: "開帳員工姓名",
    closeemployeenumber: "關帳員工編號",
    closeemployeename: "關帳員工姓名",
    opentime: "開帳時間",
    closetime: "關帳時間",
    opencash: "預備金",
    closecash: "實收現金",
    closeqty1000: "實收千元",
    closeqty500: "實收五百元",
    closeqty100: "實收百元",
    closeqty50: "實收五十元",
    closeqty10: "實收十元",
    closeqty5: "實收五元",
    closeqty1: "實收一元",
    cashdiffer: "現金差異",
    cashdiffermemo: "現金差異原因",
    closecreditcardprice: "實收信用卡",
    creditcarddiffer: "信用卡差異",
    creditcarddiffermemo: "信用卡差異原因",
    closepaytype1: "實收付款別1",
    closepaytype1price: "付款別1差異",
    paytype1differmemo: "付款別1差異原因",
    closepaytype2: "實收付款別2",
    closepaytype2price: "付款別2差異",
    paytype2differmemo: "付款別2差異原因",
    closelinepayprice: "實收LinePay",
    linepaydiffer: "LinePay差異",
    linepaydiffermemo: "LinePay差異原因",
    closepxpayprice: "實收全支付",
    pxpaydiffer: "全支付差異",
    pxpaydiffermemo: "全支付差異原因",
    closejkopayprice: "實收街口",
    jkopaydiffer: "街口差異",
    jkopaydiffermemo: "街口差異原因",
    closecollection: "實收代收",
    collectiondiffer: "代收差異",
    collectiondiffermemo: "代收差異原因",
    closepayment: "實收代支",
    paymentdiffer: "代支差異",
    paymentdiffermemo: "代支差異原因",
    requiredqty: "必選數量",
    upperlimitqty: "上限數量",
    dailylimitqty: "限購數量",
    batchnumberposition: "批號位置",
    batchnumberlength: "批號長度",
    showprice: "價格",
    orderstatustype: "訂單狀態",
    totalspent: "消費金額",
    paytypename: "付款名稱",
    holidaytime: "時間",
    active: "啟用功能",
    giftvouchernumber: "優惠券編號",
    giftvouchername: "優惠券名稱",
    foodstocktype: "存貨別",
    incounts: "內用筆數",
    intotal: "內用總計",
    outcounts: "外帶筆數",
    outtotal: "外帶總計",
    deliverycounts: "外送筆數",
    deliverytotal: "外送總計",
    pickselfcounts: "自取筆數",
    pickselftotal: "自取總計",
    sendcountformatted: "發送人數",
    sendpointformatted: "贈點",
    descriptioncondition: "條件",
    suggestprice: "建議售價",
    integralgettotal: "商品積分",
    integralget: "獲得積分",
    freeqty: "贈送數量",
    statustext: "狀態",
    pickupname: "取貨名稱",
    pickupnumber: "編號",
    pickuptype: "取貨類別",
    pickuptypetext: "取貨類別",
    erpplatformnumber: "ERP對應代碼",
    relateddocuments: "相關單據",
    saltype: "類型",
    saltypetext: "類型",
    totaladjustment: "誤差調整",
    uploadtype: "上傳類型",
    uploadtypetext: "上傳類型",
    successcount: "成功筆數",
    failcount: "失敗筆數",
    targetno: "交易序號",
    resultmessage: "錯誤訊息",
    uploadlogdetail: "記錄詳細",
    foodfreeprice: "商品折讓",
    nationality: "國籍",
    nationalitynumber: "國籍編號",
    nationalityname: "國籍名稱",
    calories: "熱量",
    duration: "時間",
    foodTaxType: "明細稅別",
    salecost: "成本小計",
    foodsalestatustype: "販售狀態",
    ordercounts: "訂單數",
    iserpplatformupload: "ERP上傳狀態",
    summary: "簡述",
    foodtaxtype: "明細稅別",
    transactiontype: "類型",
    transactiontime: "時間",
    requisitionnumber: "單號",
    requisitiondate: "請購日期",
    desireddeliverydate: "期望到貨日",
    saleqty: "期間銷售量",
    suggestrestockqty: "建議補貨量",
    initialtotalcost: "期初總成本",
    purchasetotalcost: "進貨總成本",
    purchasereturntotalcost: "進貨退出總成本",
    stockadjusttotalcost: "調整總成本",
    lastcost: "月成本",
    dailyaveragesaleqty: "日均銷售量",
    purta200: "叫貨單單號",
    purta003: "請購單日期",
    department: "部門代號",
    creator: "建立人",
    integralfreeamount: "點數折抵金額",
    foodprice: "售價",
    hardwareid: "HardwareId",
    islicensegenerated: "金鑰",
    kdsserverip: "伺服器網址(完整)",
    logintime: "登入時間",
    logouttime: "登出時間",
    loginip: "登入IP",
  },
  //columnName
  modalTitle: {
    defaultTitle: "設定",
    addShortCut: "加入捷徑",
  },
  modalButton: {
    done: "完成",
    cancel: "取消",
    select: "選擇",
  },
  message: {
    hello: "你好，世界",
  },

  //enums
  enums: {
    dateRange: {
      today: "今日",
      yesterday: "昨日",
      thisWeek: "本週",
      thisMonth: "本月",
      lastMonth: "上個月",
      thisYear: "今年",
      lastYear: "去年",
      lastSevenDays: "過去7日",
      lastThirtyDays: "過去30日",
      customize: "自訂",
    },
    taxType: {
      All: "全部",
      NoInvoice: "不開發票",
      YTax: "含稅",
      ZTax: "零稅",
      NTax: "免稅",
    },
    reportSource: {
      All: "全部",
      Local: "POS",
      Web: "網站",
      Ubereats: "UberEats",
      Backstage: "後台",
      Showmore: "Showmore",
    },
    costType: {
      NormalCost: "標準成本",
      AvgCost: "平均成本",
      LastCost: "前次進貨價",
    },
    eatSearchType: {
      All: "全部",
      In: "內用",
      Out: "外帶",
      Delivery: "外送",
      InAndOut: "內用&外帶",
      InAndDelivery: "內用&外送",
      OutAndDelivery: "外帶&外送",
      PickSelf: "自取",
      InAndPickSelf: "內用&自取",
      OutAndPickSelf: "外帶&自取",
      DeliveryAndPickSelf: "外送&自取",
      InAndOutAndDelivery: "內用&外帶&外送",
      InAndOutAndPickSelf: "內用&外帶&自取",
      InAndDeliveryAndPickSelf: "內用&外送&自取",
      OutAndDeliveryAndPickSelf: "外帶&外送&自取",
    },
    foodStatusType: {
      All: "全部",
      Normal: "正常",
      Discontinued: "停售",
    },
    rankType: {
      None: "無",
      Qty: "數量",
      Total: "總價",
    },
    businessClassType: {
      All: "全部",
    },
    visionType: {
      Myopia: "近用",
      Hyperopia: "遠用",
      Contacts: "隱形眼鏡",
      Other: "Other",
      Multifocal: "多焦",
    },
  },
  //enums

  //modal
  modal: {
    purchasenumber: "採購單號",
  },
  //modal
};
